import { AxiosError } from 'axios';
import { GET_DROPDOWN_MEDICAL_CONDITIONS_URL } from '../../constants/apiUrls';
import { GET_DROPDOWN_MEDICAL_CONDITIONS_QUERY_KEY } from '../../constants/queryKeys';
import { useCustomQuery } from '../../hooks/query';
import axiosClient from '../axiosClient';
import { MedicalCondition } from './useGetEnabledMedicalConditions';
import {GenericErrorResponse} from "../typings";

// =============================================================================
// Query
// =============================================================================
interface Input {
  onSuccess?: (data: MedicalCondition[]) => void;
  onError?: (data: AxiosError<GenericErrorResponse>) => void;
}

export const useGetDropdownMedicalConditions = ({ onSuccess, onError }: Input = {}) => {
  const getDropdownMedicalConditions = async () => {
    const res = await axiosClient.get<MedicalCondition[]>(GET_DROPDOWN_MEDICAL_CONDITIONS_URL);
    return res.data;
  };

  return useCustomQuery(GET_DROPDOWN_MEDICAL_CONDITIONS_QUERY_KEY, getDropdownMedicalConditions, {
    onSuccess,
    onError,
  });
};
